import {actions} from "react-redux-form";
import _ from "lodash";

export const setDataInStore = (dispatch: any, data: object, storeKey: string) => {
    Object.keys(data).forEach((key) => {
        dispatch(actions.change(storeKey + '.' + key, _.get(data, key, '')))
    })
}